<app-site-header />
<section class="content-area-layout1">
    <section class="content-area-layout2">
        <h3>{{vehicle}} {{model}} Firmware</h3>

        <p class="text-aerostar-orange">{{message}}</p>

        @if (firmwareFileCount > 0) {
        <div>
            <mat-accordion>
                <section class="mat-elevation-z2 mat-header-row">
                    <span class="mat-header-cell mat-cell-padding">File Name</span>
                    <span class="mat-header-cell mat-cell-padding right-align-column">Size (KB)</span>
                    <span class="mat-header-cell mat-cell-padding">Uploaded</span>
                    <span class="mat-header-cell">Actions</span>
                </section>
                <mat-expansion-panel hideToggle *ngFor="let firmwareFile of firmwareFiles">
                    <mat-expansion-panel-header class="mat-row">
                        <span class="mat-cell mat-cell-padding">{{firmwareFile.file_name}}</span>
                        <span class="mat-cell mat-cell-padding right-align-column">{{firmwareFile.sizeInKb |
                            number}}</span>
                        <span class="mat-cell mat-cell-padding">{{firmwareFile.updated_timestamp | date:'medium' :
                            'Local'}}</span>
                        <span class="mat-cell">
                            <ng-container matColumnDef="more-vert">
                                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="View and Update Actions"
                                    (click)=$event.stopPropagation()>
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item
                                        (click)="downloadFile(firmwareFile.name, firmwareFile.file_name)">
                                        <span>Download</span>
                                    </button>
                                </mat-menu>
                            </ng-container>
                        </span>
                    </mat-expansion-panel-header>
                    <div>
                        <pre>Nothing here, remove expansion panel.</pre>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

        <mat-paginator #paginator (page)="handlePageEvent($event)" [length]="firmwareFileCount" [pageSize]="pageSize"
            [disabled]="false" [showFirstLastButtons]="false" [pageSizeOptions]="[5, 10, 25]" [hidePageSize]="false"
            [pageIndex]="pageIndex" aria-label="Select page">
        </mat-paginator>
        }
        @if (firmwareFileCount == 0) {
        <p>No firmware files found</p>
        }

    </section>
</section>